module.exports = "pegasus_template/assets/blocks/column-lp3-themelp1.png";